import { useEffect } from 'react'

import { GLTFData } from '@components/adgroup-three-fiber/types'

import useCalculateVRAM from './use-calculate-vram'

interface VRAMTrackerProps {
  gltfData?: GLTFData
  onUpdate?: (value: number) => void
}

function VRAMTracker({ gltfData, onUpdate }: VRAMTrackerProps) {
  const { VRAM } = useCalculateVRAM({ scene: gltfData?.scene })

  useEffect(() => {
    onUpdate?.(VRAM)
  }, [VRAM, onUpdate])

  return null
}

export default VRAMTracker
